// extracted by mini-css-extract-plugin
export default {"button":"SharedLayout_button__F+40h","navWrapper":"SharedLayout_navWrapper__+hzC2","navSlogan":"SharedLayout_navSlogan__PtsWt"};